import { SmartModel } from "shark-mvc";

class NousCoreModel extends SmartModel {
	createdAt = "0000-00-00 00:00:00";
	createdByGuid = "";
	guid = "";
	status = 0;
	updatedAt = "0000-00-00 00:00:00";
	updatedByGuid = "";

	__createdAtLabel = "";
	__updatedAtLabel = "";
	
	constructor () {
		// super(null, {modelName});
		super();

		// if (data) {
		// 	this.import(data);
		// }
	}

	export () {
		const exportData = super.export();

		exportData.createdAt = this.exportDateField("createdAt");
		exportData.updatedAt = this.exportDateField("updatedAt");

		return exportData;
	}

	import (data, options) {
		super.import(data, options);

		if (this.importDateField("createdAt", data.createdAt)) {
			this.__createdAtLabel = this.createdAt.format("DD/MM/YYYY - HH:mm");
		}
		
		this.importNumberField("status", data.status);
		
		if (this.importDateField("updatedAt", data.updatedAt)) {
			this.__updatedAtLabel = this.updatedAt.format("DD/MM/YYYY - HH:mm");
		}
	}
}

export default NousCoreModel;